import { createSelector } from '@reduxjs/toolkit'

import Constants from 'Constants'
import { FEATURE_FLAGS } from 'settings/constants/launchDarkly'
import { get } from 'utils/lodash'

const {
  NOTIFICATION_CENTER,
  NEW_ROUTE_MANAGER,
  BILLING_WORK_ORDER_INVOICE_STATUS,
  INVOICE_BATCHING,
  PAYMENT_GROUPS,
  GCP_IP,
  NOTES_V_2,
  ACCOUNT_GROUPS,
  LATE_FEE,
  RENTAL_FEE,
  STATEMENTS,
  PAYMENTS_V15,
  ALLOW_NEGATIVE_INVOICE,
  ACCOUNTING_LOCK,
  CS_REDESIGN,
  WO_REDESIGN,
  WO_REDESIGN_V2,
  LEGACY_CS_DESIGN,
  LEGACY_WO_DESIGN,
  CS_DRAFT,
  CS_DETAILS_AVAILABLE_FEATURES,
  DISPOSAL_FEES,
  DISPOSAL_REVIEW,
  CSV_IMPORT_PAYMENTS_BATCH,
  ROUTING_SEQUENCE_CONCURRENCY,
  TAXES_REDESIGN,
} = FEATURE_FLAGS

const selectFlags = state => get(state, 'flags', {})

export const isFeatureAvailable = (flags, key) => get(flags, key, false)

// Forced on outside production: the LD flag isn't yet targeted at the logins testing against the seeded RC inboxes.
export const isNotificationFeatureAvailable = createSelector(
  selectFlags,
  flags => Constants.DEV_MODE || isFeatureAvailable(flags, NOTIFICATION_CENTER)
)

export const isNewRouteManagerFeatureAvailable = createSelector(selectFlags, flags => isFeatureAvailable(flags, NEW_ROUTE_MANAGER))

export const isBillingWOInvoiceStatusFeatureAvailable = createSelector(selectFlags, flags =>
  isFeatureAvailable(flags, BILLING_WORK_ORDER_INVOICE_STATUS)
)

export const isInvoiceBatchingFeatureAvailable = createSelector(selectFlags, flags => isFeatureAvailable(flags, INVOICE_BATCHING))

export const isPaymentGroupsFeatureAvailable = createSelector(selectFlags, flags => isFeatureAvailable(flags, PAYMENT_GROUPS))

export const isGcpIpFeatureAvailable = createSelector(selectFlags, flags => isFeatureAvailable(flags, GCP_IP))

export const isNotesV2FeatureAvailable = createSelector(selectFlags, flags => isFeatureAvailable(flags, NOTES_V_2))

export const isAccountGroupsFeatureAvailable = createSelector(selectFlags, flags => isFeatureAvailable(flags, ACCOUNT_GROUPS))

export const isLateFeeFeatureAvailable = createSelector(selectFlags, flags => isFeatureAvailable(flags, LATE_FEE))

export const isRentalFeeFeatureAvailable = createSelector(selectFlags, flags => isFeatureAvailable(flags, RENTAL_FEE))

export const isStatementsFeatureAvailable = createSelector(selectFlags, flags => isFeatureAvailable(flags, STATEMENTS))

export const isPaymentsV15FeatureAvailable = createSelector(selectFlags, flags => isFeatureAvailable(flags, PAYMENTS_V15))

export const isAllowNegativeInvoiceFeatureAvailable = createSelector(selectFlags, flags =>
  isFeatureAvailable(flags, ALLOW_NEGATIVE_INVOICE)
)

export const isAccountingLockFeatureAvailable = createSelector(selectFlags, flags => isFeatureAvailable(flags, ACCOUNTING_LOCK))

export const isCSRedesignFeatureAvailable = createSelector(selectFlags, flags => isFeatureAvailable(flags, CS_REDESIGN))

export const isWORedesignFeatureAvailable = createSelector(selectFlags, flags => isFeatureAvailable(flags, WO_REDESIGN))

export const isLegacyCSRedesignFeatureAvailable = createSelector(selectFlags, flags => isFeatureAvailable(flags, LEGACY_CS_DESIGN))

export const isLegacyWORedesignFeatureAvailable = createSelector(selectFlags, flags => isFeatureAvailable(flags, LEGACY_WO_DESIGN))

export const isWORedesignV2FeatureAvailable = createSelector(selectFlags, flags => isFeatureAvailable(flags, WO_REDESIGN_V2))

export const isCSDraftsFeatureAvailable = createSelector(selectFlags, flags => isFeatureAvailable(flags, CS_DRAFT))

export const isCSDetailsAvailableFeaturesAvailable = createSelector(selectFlags, flags =>
  isFeatureAvailable(flags, CS_DETAILS_AVAILABLE_FEATURES)
)

export const isDisposalFeesFeatureAvailable = createSelector(selectFlags, flags => isFeatureAvailable(flags, DISPOSAL_FEES))

export const isDisposalReviewFeatureAvailable = createSelector(selectFlags, flags => isFeatureAvailable(flags, DISPOSAL_REVIEW))

export const isCSVImportPaymentsBatchFeatureAvailable = createSelector(selectFlags, flags =>
  isFeatureAvailable(flags, CSV_IMPORT_PAYMENTS_BATCH)
)

export const isRoutingSequenceConcurrencyFeatureAvailable = createSelector(selectFlags, flags =>
  isFeatureAvailable(flags, ROUTING_SEQUENCE_CONCURRENCY)
)

export const isTaxesRedesignAvailable = createSelector(selectFlags, flags => isFeatureAvailable(flags, TAXES_REDESIGN))
